import { getWelcomeMessage } from '../utils/cvParser'
import { Database, Brain, Workflow } from 'lucide-react'

const About = () => {
  const message = getWelcomeMessage()

  const skills = [
    {
      icon: <Database className="w-8 h-8" />,
      title: "Data Platform Architecture",
      description: "Architecting end-to-end data platforms with modern tools like Apache Airflow, BigQuery, and cloud-native solutions."
    },
    {
      icon: <Brain className="w-8 h-8" />,
      title: "ML & AI Implementation",
      description: "Applying cutting-edge machine learning and AI techniques to transform data into actionable business insights."
    },
    {
      icon: <Workflow className="w-8 h-8" />,
      title: "Data Pipeline Automation",
      description: "Building robust, automated data extraction and processing pipelines with quality frameworks and CI/CD practices."
    }
  ]

  return (
    <section id="about" className="bg-white">
      <div className="section-container">
        <h2 className="section-title text-center">About Me</h2>
        
        <div className="max-w-4xl mx-auto mb-16">
          <p className="text-lg text-gray-700 leading-relaxed text-center">
            {message}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {skills.map((skill, index) => (
            <div key={index} className="card text-center group">
              <div className="flex justify-center mb-4 text-navy-600 group-hover:text-navy-700 transition-colors duration-300">
                {skill.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-gray-900">
                {skill.title}
              </h3>
              <p className="text-gray-600">
                {skill.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default About
